export const adqui_item = [
    {
        "nombre" : "Criterios",
        "url" : "/pdf/Criterios_para_el_Procedimiento_de_Contratacion_ante_la_Oficialia_Mayor_2025.pdf",
      /*   "descripcion":"Consulta los criterios para el procedimiento de contratación." */
    },
    {
        "nombre" : "Formato de Registro de Usuarios",
        "url" : "/pdf/Registro_de_usuarios.xlsx ",
     /*    "descripcion":"Formato para el registro de usuarios del Sistema de Compras Públicas" */
    }
]